import { Tag, Wrap, WrapItem, type WrapProps } from "@chakra-ui/react";
import { SupplierRelationDto } from "../../../autogen/bff-api";
import { useSupplierRelationLabels } from "./useSupplierRelationLabels";

interface Props extends WrapProps {
  relations: SupplierRelationDto[];
}

export const SupplierRelationTags = ({ relations, ...wrapProps }: Props) => {
  const relationLabels = useSupplierRelationLabels();
  return (
    <Wrap spacing="1" {...wrapProps}>
      {relations.map((relation) => (
        <WrapItem key={relation}>
          <Tag size="sm" colorScheme={relation === SupplierRelationDto.ActiveContract ? "teal" : "gray"}>
            {relationLabels[relation]}
          </Tag>
        </WrapItem>
      ))}
    </Wrap>
  );
};
